module.exports = __webpack_public_path__ + "static/media/EnvPromo10.c651de0b.jpg";